import React, {Component} from "react";


class TableTwoModels extends Component{
    constructor(props) {
        super(props);
        this.state = {
            settings: {"s": true, "p": true, "w": true, "m": false},
            pie_chart_color: {"possible": "rgba(2,132,199,1)", "sure": "#65a30d", "missing": "#ea8034", "wrong": "#dc2626"},
        }
    }

    activate = (c)=>{
        const {settings} = this.state
        let temp = settings
        temp[c] = !settings[c]
        this.setState({
         settings: temp
     })
    }

    render() {
        const {pairs1, pairs2, tokens1, tokens2, intersection_color, model1_name, model2_name, colors} = this.props;
        const {settings, pie_chart_color} = this.state
        const default_cell_css = "text-center px-6 py-2 mr-1 text-neutral-600"

        return (
            <div className="block text-center m-auto flex rounded">
                <div className="flex m-auto border rounded shadow-lg p-3 mt-4">
                    <div className="flex m-auto text-sm border-b-8 text-neutral-700 border-yellow-600 mr-6 pt-2 mt-0">Translation Pairs Agreement</div>

                    <div className="mr-6 border rounded p-2" style={{borderColor:colors[model1_name]}}>
                        <div className="text-xs px-2 py-1 rounded m-1 font-bold text-white "
                             style={{"backgroundColor": colors[model1_name], "fontSize": "11px"}}>{model1_name}</div>
                        {pairs1.filter(x=> !pairs2.includes(x)).length > 0?
                            pairs1.filter(x=> !pairs2.includes(x)).map((x, i)=>{
                                let ids = x.split("-")
                                console.log(ids)
                                return(

                                    <div className="text-xs px-2 py-1 m-1 font-bold text-white"
                                         style={{"color": colors[model1_name], "fontSize": "11px"}}>
                                        {tokens1[parseInt(ids[0])]} <span className="text-neutral-800">#</span>  {tokens2[parseInt(ids[1])]}</div>

                                )
                            })
                            :<span className="text-xs px-2 py-1 m-1 font-bold text-white"
                                   style={{"color": colors[model1_name], "fontSize": "11px"}}>--</span>}
                    </div>
                    <div className="mr-6 border rounded p-2" style={{borderColor:intersection_color}}>
                        <div className="text-xs px-2 py-1 rounded m-1 font-bold text-white"
                             style={{"backgroundColor": intersection_color, "fontSize": "11px"}}>Agreement</div>
                        {pairs1.filter(x=> pairs2.includes(x)).length > 0?
                            pairs1.filter(x=> pairs2.includes(x)).map((x, i)=>{
                                let ids = x.split("-")
                                return(

                                    <div className="text-xs px-2 py-1 m-1 font-bold text-white"
                                         style={{"color": intersection_color, "fontSize": "11px"}}>
                                        {tokens1[parseInt(ids[0])]} <span className="text-neutral-800">#</span> {tokens2[parseInt(ids[1])]}</div>

                                )
                            })
                            :<span className="text-xs px-2 py-1 m-1 font-bold text-white"
                                   style={{"color": intersection_color, "fontSize": "11px"}}>--</span>}
                    </div>

                    <div className="mr-6 border rounded p-2" style={{borderColor:colors[model2_name]}}>
                        <div className="text-xs px-2 py-1 rounded m-1 font-bold text-white"
                             style={{"backgroundColor": colors[model2_name], "fontSize": "11px"}}>{model2_name}</div>
                        {pairs2.filter(x=> !pairs1.includes(x)).length > 0?
                            pairs2.filter(x=> !pairs1.includes(x)).map((x, i)=>{
                                let ids = x.split("-")
                                console.log(ids)
                                return(

                                    <div className="text-xs px-2 py-1 m-1 font-bold text-white"
                                         style={{"color": colors[model2_name], "fontSize": "11px"}}>
                                        {tokens1[parseInt(ids[0])]} <span className="text-neutral-800">#</span>  {tokens2[parseInt(ids[1])]}</div>

                                )
                            })
                            :<span className="text-xs px-2 py-1 m-1 font-bold text-white"
                                   style={{"color": colors[model2_name], "fontSize": "11px"}}>--</span>}
                    </div>

                </div>
            </div>

        )
    }
}

export default TableTwoModels;